import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "io-card__product-content"
}
const _hoisted_2 = { class: "io-card__product-content__title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  class: "io-card__product-content__slogan",
  "data-eq-part": "io-card-slogan"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  class: "io-card__product-content__details row g-0",
  "data-eq-part": "io-card-product-details"
}
const _hoisted_8 = { class: "fa-ul font-regular" }
const _hoisted_9 = { class: "fa-li" }
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Expansion = _resolveComponent("Expansion")!
  const _component_FaIcon = _resolveComponent("FaIcon")!

  return (_ctx.product)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, [
            _createElementVNode("img", {
              src: _ctx.getLogoSrc(_ctx.product)
            }, null, 8, _hoisted_3)
          ]),
          (!_ctx.hasLogoSrc)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.getProductName(_ctx.product)), 1))
            : _createCommentVNode("", true)
        ]),
        _renderSlot(_ctx.$slots, "default"),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", {
            innerHTML: _ctx.product.slogan ? _ctx.product.slogan : 'Ehrlich, fair & bodenständig.'
          }, null, 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.hasContent)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["col-12", _ctx.contentFirst ? 'order-2' : 'order-1'])
              }, [
                _createVNode(_component_Expansion, {
                  expanded: _ctx.contentExpanded,
                  duration: 0.7,
                  class: "io-card__product-content__description"
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "content")
                  ]),
                  _: 3
                }, 8, ["expanded", "duration"])
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["col-12", _ctx.contentFirst ? 'order-1' : 'order-2'])
          }, [
            _createVNode(_component_Expansion, {
              expanded: _ctx.benefitsExpanded,
              duration: 0.7,
              class: "io-card__product-content__benefits"
            }, {
              default: _withCtx(() => [
                _createElementVNode("ul", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.benefits, (benefit, binx) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: `${_ctx.product.id}-benefit-${binx}`
                    }, [
                      _createElementVNode("span", _hoisted_9, [
                        _createVNode(_component_FaIcon, { icon: "far fa-check" })
                      ]),
                      _createElementVNode("span", { innerHTML: benefit }, null, 8, _hoisted_10)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["expanded", "duration"])
          ], 2)
        ])
      ]))
    : _createCommentVNode("", true)
}